// TODO this file needs refactoring
import {
  Space, Button as MantineButton, Flex, Checkbox,
} from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { ReactComponent as IconError } from "src/assets/icons/toast-error.svg";
import { ReactComponent as IconSuccess } from "src/assets/icons/toast-success.svg";
import { toTitleCase } from 'src/utils';
import usePageLandingsEvents from 'src/events/usePageLandingEvents';
import { ScreenWrapper } from '../../components';
import { OnboardingProgress } from '../../components/onboardingProgress';
import { ScreenLoader } from '../../components/screenLoader';
import { RootState } from '../../redux/store';
import { personalDetailsSteps } from '../../constants';
import { useStyles } from './personalDetails.styles';
import {
  clearPersonalDetailsFormError, savePersonalDetails, setPersonalDetails, setPersonalDetailsFormStatus,
} from './personalDetailsFormSlice';
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron-left.svg';
import { getProgressStepper } from '../../utils/helpers';
import { Button, TextInput } from '../../components/atoms';
import type { PersonalDetailsType } from './personalDetailsFormSlice';
import usePersonalDetailsEvents, { IKey } from '../../events/usePersonalDetailsEvents';

interface ButtonStyle {
  smallButton: string;
  mediumButton: string;
  largeButton: string;
}
const websiteUrl = process.env.REACT_APP_WEBSITE_URL;

export const PersonalDetails = (): JSX.Element => {
  const { classes, cx } = useStyles();
  const { TriggerPersonalDetailsEvent } = usePersonalDetailsEvents();
  const { PersonalDetailsLanding } = usePageLandingsEvents();
  const steps = personalDetailsSteps;
  const { userDetails } = useSelector((state: RootState) => state.account);
  const personalDetailsState = useSelector((state: RootState) => state.personalDetails);
  const currentStep = useSelector((state: RootState) => state.account.userDetails.currentStep);
  const [count, setCount] = useState(0);
  const [seeMore, setSeeMore] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [fatherNameVal, setFatherNameVal] = useState(userDetails.fatherName || '');
  const [motherNameVal, setMotherNameVal] = useState(userDetails.motherName || '');
  const [personalDetailsLocalCopy, setPersonalDetailsLocalCopy] = useState<PersonalDetailsType | null>(null);
  const [segments, setSegments] = useState(["NSE_FO"])
  const [isLoading, setIsLoading] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = steps[count];

  useEffect(() => {
    PersonalDetailsLanding(id as IKey)
  }, [id]);

  useEffect(() => {
    if ((fatherNameVal.length > 3)) {
      if (motherNameVal.length > 3) {
        setIsButtonDisabled(false);
      }
    }
    return () => setIsButtonDisabled(true);
  }, [fatherNameVal, motherNameVal]);

  const onFatherNameChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setFatherNameVal(e.target.value);
    setErrorMessage('');
  };

  const onMotherNameChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setMotherNameVal(e.target.value);
    setErrorMessage('');
  };
  // called on option select
  const onClick = (opt: string): void => {
    const obj: any = {};
    obj[id] = opt;
    if (id === 'segmentSelection') {
      let updatedSegments: React.SetStateAction<string[]>
      // checking if segment is already selected
      const index = segments.findIndex((segment: string) => segment === opt);
      if (index !== -1) {
        const newSegments = [...segments];
        newSegments.splice(index, 1);
        updatedSegments = newSegments
      } else {
        updatedSegments = [...segments, opt];
      }
      setSegments(updatedSegments)
      dispatch(setPersonalDetails({ ...obj, segments: updatedSegments }));
      setPersonalDetailsLocalCopy((prev: any) => ({ ...prev, segments: updatedSegments }));
    } else {
      TriggerPersonalDetailsEvent(id as IKey, obj[id])
      dispatch(setPersonalDetails({ ...obj }));
      setPersonalDetailsLocalCopy((prev: any) => ({ ...prev, ...obj }));
      setCount((prev) => prev + 1);
    }
  };
  // api call
  const onNextClick = (): void => {
    dispatch(savePersonalDetails({
      ...personalDetailsState.personalDetails,
      segments,
    }));
    TriggerPersonalDetailsEvent("segmentSelection", "true")
  };
  useEffect(() => {
    if (personalDetailsState.status === 'success') {
      dispatch(setPersonalDetailsFormStatus('idle'));
      notifications.show({
        color: 'green',
        message: 'Personal Details Saved!',
        icon: <IconSuccess />,
      });
      localStorage.removeItem('personalDetails')
      navigate('/link-bank-account');
    } else if (personalDetailsState.status === 'error') {
      dispatch(clearPersonalDetailsFormError());
      notifications.show({
        color: 'red',
        message: personalDetailsState.error.message || 'Could\'nt save personal details, Try again!',
        icon: <IconError />,
      });
    }
  }, [personalDetailsState.status]);

  const handlePreviousStep = () => {
    if (count > 0) {
      setCount((prev) => prev - 1);
    }
  };
  const getCustomStyles = (): string => {
    if (id === 'gender') {
      return 'smallButton';
    }
    if (id === 'marital_status') {
      return 'mediumButton';
    }
    return 'largeButton';
  };
  const btnStyle = getCustomStyles() as keyof ButtonStyle;

  const checkBoxOptions = (item: { value: string, option: string }) => (
    <Checkbox
      classNames={{
        root: classes.checkBoxRoot,
        body: classes.checkBoxBody,
        label: classes.checkBoxLabel,
      }}
      labelPosition="left"
      label={item.option}
      disabled={item.value === 'NSE_FO'}
      checked
    />
  )

  const renderOptions = () => {
    const currentHeadingId: keyof PersonalDetailsType = steps[count].id as keyof PersonalDetailsType;
    let alreadySelectedValue: keyof PersonalDetailsType;
    if (personalDetailsLocalCopy && currentHeadingId in personalDetailsLocalCopy) {
      alreadySelectedValue = personalDetailsLocalCopy[currentHeadingId] as keyof PersonalDetailsType;
    }
    if (steps[count].options.length > 5 && !seeMore) {
      return (
        <div className={classes.optionsWrapper}>
          {
            steps[count].options.slice(0, 5).map((item) => (
              <button
                type="button"
                className={cx(
                  classes.button,
                  classes[btnStyle],
                  alreadySelectedValue === item.value
                    ? classes.buttonSelectedAdditionalStyles
                    : null
                )}
                onClick={() => {
                  onClick(item.value);
                }}
                key={item.value}
              >
                {item.option}
              </button>
            ))
          }
          <button
            type="button"
            className={cx(classes.button, classes[btnStyle])}
            onClick={() => {
              setSeeMore(true);
            }}
            key="other"
          >
            View More
          </button>
        </div>
      );
    }
    return (
      <div className={classes.optionsWrapper}>
        {steps[count].options.map((item) => (
          id !== 'segmentSelection'
            ? (
              <button
                type="button"
                className={cx(
                  classes.button,
                  classes[btnStyle],
                  alreadySelectedValue === item.value
                    ? classes.buttonSelectedAdditionalStyles
                    : null
                )}
                // onClick={() => onClick(item.value)}
                // TODO this can be done better
                onClick={item.value !== "NSE_CM" ? () => onClick(item.value) : () => null}
                key={item.value}
              >
                {item.option}
              </button>
            ) : (
              // checkbox selection
              <button
                type="button"
                className={cx(
                  classes.button,
                  classes[btnStyle],
                  segments.includes(item.value)
                    ? classes.buttonSelectedAdditionalStyles
                    : null
                )}
                // onClick={item.value !== "NSE_CM" ? () => onClick(item.value) : () => null}
                key={item.value}
              >
                {checkBoxOptions(item)}
              </button>
            )
        ))}
      </div>
    );
  };

  const renderBackButton = () => (
    <div>
      <MantineButton onClick={handlePreviousStep} radius={8} variant="subtle" leftIcon={<ChevronIcon />}>
        Back
      </MantineButton>
    </div>
  );

  // read from local storage
  useEffect(() => {
    const localPersonalDetails = localStorage.getItem('personalDetails');
    if (localPersonalDetails !== 'undefined') {
      const parsedData = JSON.parse(localPersonalDetails || '{}');
      setPersonalDetailsLocalCopy(parsedData);
      dispatch(setPersonalDetails(parsedData))
      if (parsedData.fatherName) {
        setFatherNameVal(parsedData.fatherName);
      }
      if (parsedData.motherName) {
        setMotherNameVal(parsedData.motherName);
      }
      if (parsedData.fatherName && parsedData.motherName) {
        setCount((Object.keys(parsedData).length - 2) || 0)
      } else {
        setCount((Object.keys(parsedData).length) || 0)
      }
    }
    setIsLoading(false);
  }, []);

  // write to local storage
  useEffect(() => {
    if (personalDetailsLocalCopy) {
      localStorage.setItem('personalDetails', JSON.stringify(personalDetailsLocalCopy));
    }
  }, [personalDetailsLocalCopy]);

  // Proceed to next screen on enter key press
  useEffect(() => {
    if (count === (steps.length - 1)) {
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          onNextClick();
        }
      });
    }
  }, [count]);

  const toNextStep = () => {
    setCount((prev) => prev + 1)
  }
  const onSubmitParentsName = () => {
    const parentsDetails = {
      fatherName: toTitleCase(fatherNameVal),
      motherName: toTitleCase(motherNameVal),
    }
    dispatch(setPersonalDetails({ ...parentsDetails }));
    TriggerPersonalDetailsEvent("fatherName", "false")
    setPersonalDetailsLocalCopy((prev: any) => ({ ...prev, ...parentsDetails }));
    setCount((prev) => prev + 1);
  }
  const renderNextButton = () => {
    // Final step
    if (count === steps.length - 1) {
      return (
        <Button
          // disabled={isButtonDisabled}
          onClick={onNextClick}
        >
          Next
        </Button>
      );
    }
    // Parents name
    if (count === steps.length - 2) {
      return (
        <Button
          disabled={isButtonDisabled}
          onClick={onSubmitParentsName}
        >
          Next
        </Button>
      );
    }
    if (personalDetailsLocalCopy && Object.keys(personalDetailsLocalCopy as {}).length <= count) {
      return null;
    }
    return (
      <Button
        onClick={toNextStep}
      >
        Next
      </Button>
    );
  }

  return (
    <ScreenWrapper>
      <div className="csMainContainer">
        <div className="csHeader">
          <div className="csProgressWrapper">
            <OnboardingProgress progress={getProgressStepper(currentStep)} />
          </div>
        </div>
        <div className={classes.contentContainer}>
          <h2 className={cx("csHeading", classes.mb6)}>
            {steps[count].heading}
          </h2>
          <p className={cx("csDescription", classes.mb16)}>
            {steps[count].description}
          </p>
          {id === "fatherName" ? (
            <>
              <div className={classes.inputWrapper}>
                <TextInput
                  type="text"
                  maxLength={30}
                  name="Father's name input"
                  id="name-input"
                  title="Father's Name input"
                  autoComplete="off"
                  placeholder="Father's Name"
                  onChange={onFatherNameChange}
                  value={toTitleCase(fatherNameVal)}
                />
                <Space h="lg" />
                <TextInput
                  type="text"
                  maxLength={30}
                  name="Mother's name input"
                  id="name-input"
                  title="Mother's Name input"
                  autoComplete="off"
                  placeholder="Mother's Name"
                  onChange={onMotherNameChange}
                  value={toTitleCase(motherNameVal)}
                />
              </div>
              {errorMessage && (
                <p className={cx(classes.inputDescription, classes.inputError)}>
                  {errorMessage}
                </p>
              )}
            </>
          ) : (
            renderOptions()
          )}
          {/* Charges Display in case of segment selection */}
          {id === "segmentSelection" ? (
            <div className={classes.chargesWrapper}>
              <Flex
                className={classes.chargesTitle}
                justify="space-between"
                pb={12}
              >
                <p className="content_sm_semibold">Charges & Fees</p>
                <a
                  href={`${websiteUrl}/pricing/`}
                  target="_blank"
                  className={`${classes.learnMoreCta} heading_2xs_semibold text_primary_default`}
                  rel="noreferrer"
                >
                  Learn More
                </a>
              </Flex>
              <Flex justify="space-between" pt={12}>
                <p className="content_sm_regular">Intraday, Delivery, F&O</p>
                <p className="content_sm_regular text_fg_subtle">Rs 20/order</p>
              </Flex>
            </div>
          ) : null}
        </div>
        <div className="csFooter">
          <div className={classes.leftButton}>
            {count === 0 ? null : renderBackButton()}
          </div>
          <div className={classes.rightButton}>{renderNextButton()}</div>
        </div>
      </div>
      {personalDetailsState.status === "loading" || isLoading ? (
        <ScreenLoader />
      ) : null}
    </ScreenWrapper>
  );
};

export default PersonalDetails;
